module.exports = __webpack_public_path__ + "fa-light-300.woff2?23fbd7c6763eca9c0d6079b3c56c5b1f";